import * as yup from 'yup';

export default initialValues =>
  yup.object().shape(
    Object.keys(initialValues).reduce((acc, key) => {
      acc[key] = yup.string().required();
      return acc;
    }, {}),
  );
